<template>
  <div style="width: 550px">
    <div class="mp-modal-card">
      <template v-if="!savedApiKey">
        <p class="has-text-weight-bold is-size-4 mb-0">
          {{ $t("mp:api_keys.create.title") }}
        </p>
        <form @submit.prevent="save" v-if="!submitted" class="mt-5">
          <validation-observer ref="observer">
            <ApplicationTemplate
              class="mb-5"
              template="MERCHANT_API_KEY_CREATE_DESCRIPTION"
            ></ApplicationTemplate>

            <BInputWithValidation
              :label="$t('mp:api_keys.create.input.name.label')"
              rules="required"
              label-position="on-border"
              v-model="createRequest.name"
            />

            <BInputWithValidation
              :label="$t('mp:api_keys.create.input.daily_limit.label')"
              rules="required|integer|min_value:1"
              label-position="on-border"
              type="number"
              v-model.number="createRequest.dailyApiLimit"
              :placeholder="
                $t('mp:api_keys.create.input.daily_limit.placeholder')
              "
              class="mt-4"
            />

            <BInputWithValidation
              :label="$t('mp:api_keys.create.input.minutely_limit.label')"
              rules="required|integer|min_value:1"
              label-position="on-border"
              type="number"
              v-model.number="createRequest.minutelyApiLimit"
              :placeholder="
                $t('mp:api_keys.create.input.minutely_limit.placeholder')
              "
              class="mt-4"
            />

            <div class="mt-6 is-flex">
              <b-button
                type="is-blue"
                native-type="submit"
                class="ml-auto mr-2"
              >
                {{ $t("mp:api_keys.create.button.create") }}</b-button
              >

              <b-button type="is-text" @click="close">
                {{ $t("mp:api_keys.create.button.cancel") }}</b-button
              >
            </div>
          </validation-observer>
        </form>
        <LoadingSkeleton v-else class="mt-2" />
      </template>

      <template v-else>
        <p class="has-text-weight-bold is-size-4">
          {{ $t("mp:api_keys.create.success.title") }}
        </p>

        <p class="mt-5">
          {{ $t("mp:api_keys.create.success.description") }}
        </p>

        <p>
          {{ $t("mp:api_keys.create.success.api_key.label") }}
          <b>{{ savedApiKey }}</b>
        </p>

        <div class="mt-6 is-flex">
          <b-button type="is-blue" class="ml-auto" @click="close">
            {{ $t("mp:api_keys.create.button.close") }}</b-button
          >
        </div>
      </template>

      <div class="close-btn cursor-pointer" @click="close">
        <b-icon icon-pack="fas" icon="times" type="is-grey-icon" />
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "../../plugins/i18n";
import LoadingSkeleton from "../../components/LoadingSkeleton";
import ApplicationTemplate from "../application/ApplicationTemplate";

export default {
  name: "MerchantApiKeyCreateModal",
  components: {
    ApplicationTemplate,
    LoadingSkeleton,
    BInputWithValidation: () =>
      import("@/components/input/BInputWithValidation.vue"),
  },
  data() {
    return {
      isOpen: false,
      savedApiKey: null,
      submitted: false,
      createRequest: {
        name: "",
        ownerType: "MERCHANT",
        dailyApiLimit: null,
        minutelyApiLimit: null,
      },
    };
  },
  methods: {
    close() {
      this.$parent.close();
    },
    async save() {
      const valid = await this.$refs.observer.validate();

      if (!valid) return;

      this.submitted = true;

      try {
        this.savedApiKey = await this.$store.dispatch(
          "apiKeys/create",
          this.createRequest
        );
        this.$emit("save");
      } catch (e) {
        this.$buefy.toast.open({
          message: i18n.t("mp:api_keys.create.failure.message"),
          type: "is-danger",
        });
      }

      this.submitted = false;
    },
  },
};
</script>
